import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { Inventory2, LocalShipping, CheckCircle, Cancel } from '@mui/icons-material';

// Status always ships with an icon + label, never colour alone
export const ORDER_STATUS = {
    // Same colours as the customer's My orders page (design-system.md §12.2)
    preparing: { label: 'Preparing', icon: Inventory2, color: '#9A5B13', bg: '#FFF4E5', next: 'onWay', nextLabel: 'Mark as shipped' },
    onWay: { label: 'On the way', icon: LocalShipping, color: '#1F4E79', bg: '#E6F1FA', next: 'delivered', nextLabel: 'Mark as delivered' },
    delivered: { label: 'Delivered', icon: CheckCircle, color: '#1E6B3A', bg: '#E8F5EC', next: null },
    cancelled: { label: 'Cancelled', icon: Cancel, color: '#8B0000', bg: '#FBEAEA', next: null }
};

const StatusBadge = ({ status, size = 'md' }) => {
    const s = ORDER_STATUS[status] || ORDER_STATUS.preparing;
    const StatusIcon = s.icon;
    return (
        <Box as='span' display='inline-flex' alignItems='center' gap={1} px={size === 'sm' ? 2 : 2.5} py={size === 'sm' ? 0.5 : 1} borderRadius='full' bg={s.bg} color={s.color} whiteSpace='nowrap' >
            <StatusIcon sx={{ fontSize: size === 'sm' ? 14 : 16 }} />
            <Text as='span' fontSize={size === 'sm' ? 12 : 13} fontWeight={600} >{s.label}</Text>
        </Box>
    );
};

export default StatusBadge;
